<template>
    <div id="lms-header" class=" menu__map menu__bgHeader" ref="menuHome">
        <div class="container flex js-container-header">
            <div class="menu__map--content---logos"><!-- alignVerticalStart -->
                <img v-if="logo_" id="logomap" style="cursor:pointer;"
                     v-on:click="goHomeLMS()"
                     ref="logo" :src="logo_"
                     @error="errorImage" alt="Logo" :title="descs.logo.description">
                <div :class="'infos flex flex-wrap alignVerticalEnd ' +(this.$route.name == 'Map' ? 'blueHeader' : '')">

                    <div v-if="this.switch.btn_promotional.active" style="width: 360px;">
                        <BtnPromotional v-if="this.switch.btn_promotional.active && !this.isGuest"/>
                    </div>
                </div>
            </div>

            <div class="menu__map--content---mapMenu alignVerticalEnd">
                <div class="gap-4"
                     :class="'infos flex flex-wrap alignVerticalEnd ' +(this.$route.name == 'Map' ? 'blueHeader' : '')">

                    <!-- Hamburguer-->
                    <div class="alignVertical" id="menu_list" :class="{'show-notifications-mark' : this.switch.event_menu
                            && this.switch.event_menu['notificacoes'] && notifications_pendent_ids.length > 0}"
                         @mouseleave="closeDropdown">

                        <div class="dropdown">
                            <span style="cursor:pointer; margin: 0 0 0 auto !important;" id="menu-list"
                                  ref="menu_list">
                                <i class="bi bi-list"></i>
                            </span>
                            <span style="cursor:pointer; margin: 0 0 0 auto !important;" id="menu-list-click" @click="toggleMenu()"
                                  ref="menu_list">
                                <i class="bi bi-list"></i>
                            </span>

                            <div class="dropdown-menu hamburguer-menu" :class="{'keep-open': showNotifications}" aria-labelledby="dropdownMenuButton"
                                 ref="notificationsMenu">

                                <template v-if="!showNotifications">

                                    <span style="cursor:pointer; margin: 0 0 0 auto !important;" id="menu-list-close" @click="toggleMenu()" ref="menu_list">
                                        <i class="bi bi-x"></i>
                                    </span>
                                    <div class="user-picture mt-2" style="margin-bottom: 0.3rem !important;">
                                        <div class="d-flex">
                                            <div class="picture">
                                                <img class="user-avatar" v-if="this.user_picture" :src="this.user_picture" alt="User Avatar">
                                                <img v-else :src="`https://ui-avatars.com/api/?name=${ this.nickname }&amp;color=13b5eb&amp;background=ffffff`"
                                                     alt="" class="avatar_bottom_half">
                                            </div>
                                            <div class="user-info my-auto d-flex flex-column col">
                                                <span class="user-info-name" :title="name">{{ name }}</span>
                                                <span class="user-info-email" :title="email">{{ email }}</span>
                                            </div>
                                        </div>
                                        <div class="currency d-flex justify-content-between"><!-- my-2 py-3 -->
                                            <div v-if="this.switch.event_menu && this.switch.event_menu['score_pontos']">
                                                <div style="margin-right: 10px; padding-right: 5px;" id="point" v-if="this.switch.Habilitar_Pontos && this.switch.points_on_header"
                                                     class="alignVerticalStart"
                                                     v-on:click="exitLocal(pointsExit)" :title="descs.points.description">
                                                    <svg width="20" height="21" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4.75437 1.38428C4.72845 1.38405 4.70287 1.39026 4.67995 1.40237C4.65703 1.41447 4.63748 1.43209 4.62307 1.45364C4.60865 1.47519 4.59982 1.49998 4.59738 1.52579C4.59493 1.55159 4.59894 1.5776 4.60906 1.60147L4.6989 1.81358L6.28874 5.52062C6.29955 5.54583 6.3168 5.56775 6.33876 5.58419C6.36073 5.60062 6.38663 5.61098 6.41387 5.61422C6.44111 5.61747 6.46872 5.61349 6.49393 5.60268C6.51914 5.59187 6.54106 5.57462 6.55749 5.55265L9.49187 1.63428C9.50928 1.61107 9.51988 1.58347 9.52249 1.55457C9.52509 1.52567 9.5196 1.49661 9.50662 1.47066C9.49365 1.4447 9.4737 1.42288 9.44901 1.40762C9.42433 1.39236 9.39589 1.38428 9.36687 1.38428H4.75437Z" fill="var(--buttons_color)"/>
                                                        <path d="M16.4034 2.40222L14.7909 6.16667C14.7807 6.19044 14.7766 6.21635 14.779 6.24208C14.7813 6.26782 14.79 6.29257 14.8042 6.31413C14.8184 6.33569 14.8378 6.35338 14.8606 6.36562C14.8833 6.37785 14.9088 6.38426 14.9346 6.38425H18.8799C18.9078 6.38426 18.9351 6.37683 18.9592 6.36271C18.9832 6.3486 19.003 6.32832 19.0165 6.30398C19.0301 6.27963 19.0369 6.25211 19.0362 6.22426C19.0355 6.19641 19.0274 6.16924 19.0127 6.14558L16.6795 2.38152C16.6645 2.35729 16.643 2.33764 16.6176 2.32472C16.5921 2.31181 16.5636 2.3061 16.5352 2.30824C16.5067 2.31037 16.4794 2.32026 16.4561 2.33683C16.4329 2.3534 16.4147 2.37601 16.4034 2.40222Z" fill="var(--buttons_color)"/>
                                                        <path d="M3.32077 2.38313L0.988351 6.14563C0.973656 6.1693 0.965555 6.19647 0.964889 6.22432C0.964222 6.25217 0.971013 6.27969 0.984559 6.30403C0.998106 6.32838 1.01791 6.34866 1.04193 6.36277C1.06595 6.37688 1.09331 6.38432 1.12116 6.38431H5.06648C5.09233 6.38428 5.11778 6.37783 5.14053 6.36554C5.16328 6.35326 5.18263 6.33552 5.19684 6.31392C5.21105 6.29231 5.21967 6.26752 5.22194 6.24177C5.22421 6.21601 5.22005 6.19009 5.20984 6.16634L3.59421 2.40383C3.58266 2.37828 3.56443 2.3563 3.54146 2.34021C3.51848 2.32412 3.4916 2.31451 3.46363 2.3124C3.43566 2.31028 3.40764 2.31573 3.3825 2.32817C3.35737 2.34062 3.33604 2.3596 3.32077 2.38313V2.38313Z" fill="var(--buttons_color)"/>
                                                        <path d="M15.3624 1.38428H10.462C10.4479 1.38419 10.434 1.38805 10.4219 1.39544C10.4099 1.40283 10.4001 1.41344 10.3938 1.42608C10.3874 1.43872 10.3848 1.45288 10.3861 1.46696C10.3873 1.48104 10.3925 1.49448 10.4011 1.50576L13.5229 5.66436C13.5309 5.67504 13.5416 5.68344 13.5538 5.68869C13.5661 5.69395 13.5795 5.69588 13.5927 5.6943C13.6059 5.69271 13.6185 5.68766 13.6292 5.67967C13.6398 5.67167 13.6482 5.661 13.6534 5.64874L15.2972 1.81397L15.43 1.48819C15.4347 1.477 15.4366 1.46485 15.4355 1.45278C15.4345 1.4407 15.4305 1.42905 15.424 1.41884C15.4175 1.40862 15.4085 1.40014 15.398 1.39413C15.3875 1.38811 15.3757 1.38473 15.3636 1.38428H15.3624Z" fill="var(--buttons_color)"/>
                                                        <path d="M9.33616 17.6343L5.8428 7.73232C5.83254 7.70357 5.81362 7.6787 5.78865 7.66114C5.76368 7.64359 5.73387 7.6342 5.70334 7.63428H1.00413C0.976904 7.6342 0.950208 7.64177 0.927079 7.65613C0.90395 7.67048 0.885319 7.69105 0.873308 7.71547C0.861297 7.7399 0.856389 7.76722 0.859145 7.7943C0.8619 7.82138 0.872207 7.84714 0.888892 7.86865L9.32639 18.7987C9.35495 18.8357 9.3957 18.8614 9.4414 18.8712C9.48709 18.881 9.53478 18.8743 9.576 18.8522C9.61746 18.8304 9.64969 18.7944 9.66683 18.7509C9.68397 18.7073 9.68487 18.659 9.66936 18.6147L9.33616 17.6343Z" fill="var(--buttons_color)"/>
                                                        <path d="M18.9956 7.63428H14.2964C14.266 7.63427 14.2364 7.6437 14.2116 7.66127C14.1868 7.67883 14.1681 7.70366 14.1581 7.73232L10.3222 18.5979C10.3061 18.6436 10.3067 18.6934 10.324 18.7386C10.3414 18.7838 10.3742 18.8213 10.4167 18.8444C10.4592 18.8674 10.5085 18.8746 10.5558 18.8647C10.6031 18.8547 10.6453 18.8283 10.6749 18.7901L19.1108 7.86865C19.1275 7.84714 19.1378 7.82138 19.1406 7.7943C19.1433 7.76722 19.1384 7.7399 19.1264 7.71547C19.1144 7.69105 19.0958 7.67048 19.0727 7.65613C19.0495 7.64177 19.0228 7.6342 18.9956 7.63428V7.63428Z" fill="var(--buttons_color)"/>
                                                        <path d="M10.1251 3.21747L12.3126 6.13427C12.33 6.15748 12.3406 6.18508 12.3432 6.21398C12.3458 6.24288 12.3403 6.27194 12.3274 6.29789C12.3144 6.32385 12.2944 6.34567 12.2697 6.36093C12.2451 6.37618 12.2166 6.38426 12.1876 6.38426H7.8126C7.78358 6.38426 7.75514 6.37618 7.73046 6.36093C7.70577 6.34567 7.68582 6.32385 7.67285 6.29789C7.65987 6.27194 7.65438 6.24288 7.65698 6.21398C7.65959 6.18508 7.67019 6.15748 7.6876 6.13427L9.8751 3.21747C9.88966 3.19806 9.90853 3.18231 9.93022 3.17146C9.95192 3.16062 9.97584 3.15497 10.0001 3.15497C10.0244 3.15497 10.0483 3.16062 10.07 3.17146C10.0917 3.18231 10.1105 3.19806 10.1251 3.21747V3.21747ZM9.85166 15.339L7.20713 7.84247C7.19883 7.81891 7.19629 7.79371 7.19973 7.76897C7.20318 7.74423 7.2125 7.72068 7.22693 7.70029C7.24135 7.67989 7.26045 7.66326 7.28263 7.65177C7.30481 7.64028 7.32942 7.63428 7.3544 7.63426H12.6458C12.6708 7.63428 12.6954 7.64028 12.7176 7.65177C12.7397 7.66326 12.7589 7.67989 12.7733 7.70029C12.7877 7.72068 12.797 7.74423 12.8005 7.76897C12.8039 7.79371 12.8014 7.81891 12.7931 7.84247L10.1474 15.339C10.1366 15.3694 10.1166 15.3957 10.0903 15.4144C10.0639 15.433 10.0324 15.443 10.0001 15.443C9.96781 15.443 9.93632 15.433 9.90995 15.4144C9.88358 15.3957 9.86363 15.3694 9.85283 15.339H9.85166Z" fill="var(--buttons_color)"/>
                                                    </svg>
                                                    <p style="align-items: center;">{{ TotalPoints }}</p>
                                                </div>

                                            </div>

                                            <div v-if="this.switch.event_menu && this.switch.event_menu['score_moedas']">
                                                <div style="margin-risMobileight: 10px; padding-right: 5px;" id="coin" v-if="this.switch.Habilitar_Moedas && this.switch.coins_on_header"
                                                     class="alignVerticalStart" v-on:click="openPackage"
                                                >

                                                    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M17.6185 10.9523V13.8095C17.6185 15.0476 14.6337 16.6666 10.9518 16.6666C7.26992 16.6666 4.28516 15.0476 4.28516 13.8095V11.4285" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M4.56445 11.6752C5.38826 12.7686 7.93588 13.7943 10.9511 13.7943C14.633 13.7943 17.6178 12.2648 17.6178 10.9505C17.6178 10.2124 16.6778 9.4038 15.2025 8.83618" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M14.7611 6.19043V9.04757C14.7611 10.2857 11.7763 11.9047 8.0944 11.9047C4.4125 11.9047 1.42773 10.2857 1.42773 9.04757V6.19043" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.0944 9.03236C11.7763 9.03236 14.7611 7.50284 14.7611 6.18855C14.7611 4.87331 11.7763 3.33331 8.0944 3.33331C4.4125 3.33331 1.42773 4.87331 1.42773 6.18855C1.42773 7.50284 4.4125 9.03236 8.0944 9.03236Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                    <p>{{ TotalCoins }}</p>
                                                </div>
                                            </div>

                                            <div v-if="this.switch.enable_badge_counter">
                                                <div style="margin-right: 10px; padding-right: 5px;" id="badgeCounter" v-if="this.switch.enable_badge_counter"
                                                     class="alignVerticalEnd"
                                                     v-on:click="redirectTo('badges')" :title="descs.badges.description">
                                                    <svg width="20" height="21" viewBox="0 0 85 104" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M85 47.2727C85 73.5091 66.8667 98.0436 42.5 104C18.1333 98.0436 0 73.5091 0 47.2727V18.9091L42.5 0L85 18.9091V47.2727ZM42.5 94.5454C60.2083 89.8182 75.5556 68.7345 75.5556 48.3127V25.0545L42.5 10.3055L9.44444 25.0545V48.3127C9.44444 68.7345 24.7917 89.8182 42.5 94.5454ZM56.9028 70.9091L42.3583 62.1636L27.8611 70.9091L31.6861 54.3636L18.8889 43.3018L35.7944 41.8364L42.3583 26.2364L48.9694 41.7891L65.875 43.2545L53.0306 54.3636L56.9028 70.9091Z" fill="var(--buttons_color)"/>
                                                    </svg>
                                                    <p>{{ TotalBadges }}</p>

                                                </div>
                                            </div>


                                        </div>


                                        <div class="option-features d-flex justify-content-between align-items-center">

                                            <div class="iconLanguage alignVertical" style="display:block" v-if="this.switch.multilanguages">

                                                <div class="dropdown dropdown-locale">
                                                    <a class="dropdown-item dropdown-toggle" href="#" role="button" id="internalDropdown"
                                                       data-toggle="dropdown"
                                                       @click="openDropdownLocale">
                                                        <img :src="selectedLanguage[0].icon" :alt="selectedLanguage[0].language"
                                                             width="18" height="18" :key="selectedLanguage[0].code"/>
                                                        <span class="language">{{ selectedLanguage[0].language }}</span>
                                                    </a>
                                                    <div class="dropdown-menu dropdown-menu-locale" :class="{ show: isOpenLocale }">
                                                        <a class="dropdown-item" v-for="(lang, idx) in options" :key="idx" @click="setLocale(lang.code)">
                                                            <img :src="lang.icon" :alt="lang.language" width="18" height="18"/>
                                                            {{ lang.language }}
                                                        </a>

                                                    </div>
                                                </div>

                                            </div>

                                            <div v-if="this.switch.radio"
                                                 :title="descs.radio.description">
                                                <!--                      <MusicPlayer class="icon alignVertical" :radios="radio"/>-->
                                            </div>

                                        </div>

                                    </div>
                                    <div class="menu-links-wrapper">
                                    <div class="menu-links-inner">
                                        <router-link :to="{ path: `/lms/${lmsSlug}/profile/` }" class="dropdown-item">
                                            {{ $i18n.t("lms.header.profile") }}
                                        </router-link>
                                        <router-link :to="{ name: 'LmsStudentProgress', params: {lmsSlug: lmsSlug} }" class="dropdown-item">
                                            {{ $i18n.t("lms.header.student_progress") }}
                                        </router-link>
                                        <router-link :to="{ name: 'LmsLibrary' }" class="dropdown-item">
                                            {{ $i18n.t("lms.header.library") }}
                                        </router-link>
                                        <router-link :to="{ name: 'LmsStudentBook' }" class="dropdown-item">
                                            {{ $i18n.t("lms.student_book.title") }}
                                        </router-link>
                                        <router-link :to="{ name: 'LmsCertificates' }" class="dropdown-item">
                                            {{ $i18n.t("lms.header.certificates") }}
                                        </router-link>
                                        <!-- <a class="dropdown-item d-none" href="#">Benefícios</a> -->
                                        <router-link :to="{ name: 'LmsFriends' }" class="dropdown-item">
                                            {{ $i18n.t("lms.header.friends") }}
                                        </router-link>
<!--                                        <router-link :to="{ name: 'LmsNotifications', params: {lmsSlug: lmsSlug}}" class="dropdown-item">-->
<!--                                            {{ $i18n.t("lms.header.notifications") }}-->
<!--                                            <span class="notifications-count" v-if="this.switch.event_menu && this.switch.event_menu['notificacoes'] && notifications_pendent_ids.length > 0">-->
<!--                                                {{ notifications_pendent_ids.length }}-->
<!--                                            </span>-->
<!--                                        </router-link>-->
                                        <span class="dropdown-item menu-notifications" @click.stop="notificationsHandler()">Notificações</span>
                                        <router-link :to="{ name: 'LmsPayments'}" class="dropdown-item">
                                            {{ $i18n.t("lms.header.payments") }}
                                        </router-link>
                                        <router-link :to="{ name: 'Support'}" class="dropdown-item">
                                            {{ $i18n.t("lms.header.faq") }}
                                        </router-link>

                                        <a v-if="this.switch.without_landing_page != 'without_landing_page' || this.logged"
                                           class="dropdown-item"
                                           :title="descs.shutoff.description"
                                           @click.prevent="logout">
                                            {{ $i18n.t("lms.header.logout") }}
                                        </a>
                                    </div>
                                </div>
                                </template>
                                <template v-else>

                                    <!-- <LmsMenuNotifications /> -->

<!--                                    <div class="notifications">-->
<!--                                        <span>asdf</span>-->
<!--                                    </div>-->
                                </template>


                            </div>

                        </div>
                    </div>

                    <div class="alignVertical" id="menu_cart" @click="goToCheckout" v-if="getShowCart()">
                        <span :class="(this.cartHasItens ? 'canCheckout' : '')" style="margin: 0 0 0 auto !important;" id="menu-cart"
                              ref="menu_cart">
                        <i class="bi bi-cart"></i>
                    <div :class="(this.cartHasItens ? ' notification-cart' : '')"></div>

              </span>
                    </div>

                    <!-- <div v-if="!this.isGuest && (!this.isMobile || this.switch.btn_promotional.active)">-->
                </div>

                <div v-if="tools && !isLms" class="tools alignVerticalEnd noWarp gap-3">

                    <div id="_menu" v-if="this.smartphone_options"
                         v-on:click="notification = false;camera = false;$refs['mobile'].mobileHandler();"
                         :title="descs.menu.description"
                         class="icon alignVertical">
                        <svg width="15" height="21" viewBox="-2 0 16 21" fill="var(--buttons_color)"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M7.5 3.5C7.5 2.64753 7.76667 1.85735 8.22114 1.20831H2.20833C1.59722 1.20831 1.07639 1.43054 0.645833 1.87498C0.215278 2.31942 0 2.8472 0 3.45831V18.5416C0 19.1528 0.215278 19.6805 0.645833 20.125C1.07639 20.5694 1.59722 20.7916 2.20833 20.7916H9.33333C9.94445 20.7916 10.4653 20.5694 10.8958 20.125C11.3264 19.6805 11.5417 19.1528 11.5417 18.5416V7.49979L11.5 7.5C10.8889 7.5 10.3097 7.36294 9.79167 7.11789V16.3333H1.79167V3.87498H7.51734C7.50587 3.75153 7.5 3.62645 7.5 3.5ZM6.72917 19.5C6.46528 19.75 6.14583 19.875 5.77083 19.875C5.39583 19.875 5.08333 19.75 4.83333 19.5C4.58333 19.25 4.45833 18.9375 4.45833 18.5625C4.45833 18.1875 4.58333 17.868 4.83333 17.6041C5.08333 17.3403 5.39583 17.2083 5.77083 17.2083C6.14583 17.2083 6.46528 17.3403 6.72917 17.6041C6.99306 17.868 7.125 18.1875 7.125 18.5625C7.125 18.9375 6.99306 19.25 6.72917 19.5Z"
                                  fill="var(--buttons_color)"/>
                            <path
                                d="M11.7 6.11571C13.1912 6.11571 14.4 4.94142 14.4 3.49285C14.4 2.04429 13.1912 0.869995 11.7 0.869995C10.2088 0.869995 9 2.04429 9 3.49285C9 4.94142 10.2088 6.11571 11.7 6.11571Z"
                                fill="var(--buttons_color)"/>
                        </svg>
                    </div>
                    <div
                        v-if="LibraryName && LibraryName.length>0 && this.switch.event_menu && this.switch.event_menu['biblioteca']"
                        v-on:click="notification = false;camera = false;conteudoHandler();mobileClose()"
                        class="icon alignVertical"
                        :title="LibraryName"
                    >
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M1.51505 13.9146C1.38205 13.8138 1.40025 13.6472 1.40025 13.6472L2.13665 4.89997C2.13665 4.89997 2.14785 4.80337 2.19125 4.75437C2.21785 4.72357 2.25145 4.67877 2.31725 4.65217C3.05505 4.34977 7.07445 2.17277 9.10026 4.19997C9.43626 4.58917 9.80026 5.16317 9.80026 5.59997V13.0032C9.80026 13.0032 9.80866 13.16 9.66726 13.2552C9.61567 13.2842 9.5576 13.2999 9.49839 13.3006C9.43918 13.3013 9.38074 13.2872 9.32846 13.2594C6.21205 11.6998 2.73305 13.475 1.85525 13.9412C1.80211 13.9706 1.74145 13.9836 1.68092 13.9786C1.62039 13.9736 1.56268 13.9509 1.51505 13.9132V13.9146ZM19.1453 13.9412C18.2675 13.475 14.7885 11.7012 11.6721 13.2594C11.6198 13.2872 11.5613 13.3013 11.5021 13.3006C11.4429 13.2999 11.3848 13.2842 11.3333 13.2552C11.1919 13.16 11.2003 13.0032 11.2003 13.0032V5.59997C11.2003 5.16317 11.5643 4.58917 11.9003 4.19997C13.9247 2.17277 17.9203 4.34977 18.6581 4.65217C18.7225 4.67877 18.7561 4.72357 18.7841 4.75437C18.8261 4.80337 18.8387 4.89997 18.8387 4.89997L19.5989 13.6472C19.5989 13.6472 19.6185 13.8138 19.4869 13.9132C19.4391 13.9512 19.3811 13.9741 19.3203 13.9791C19.2595 13.9841 19.1986 13.9709 19.1453 13.9412V13.9412ZM12.4113 17.7604C12.4759 17.7418 12.5334 17.7042 12.5765 17.6526C12.6098 17.6081 12.6302 17.5553 12.6353 17.5C12.7053 16.1868 14.9089 14.9632 19.1425 17.458C19.2503 17.5196 19.3749 17.514 19.4813 17.437C19.6017 17.3488 19.6003 17.199 19.6003 17.199V16.4248C19.6003 16.4248 19.6003 16.317 19.5625 16.2582C19.5312 16.207 19.486 16.1658 19.4323 16.1392C16.5973 14.2982 13.0119 13.482 11.1933 15.9152C11.1726 15.9665 11.137 16.0104 11.0911 16.0412C11.0113 16.1042 10.9147 16.1 10.9147 16.1H10.0957C10.0957 16.1 9.99766 16.1042 9.91926 16.0426C9.87333 16.0118 9.83772 15.9679 9.81706 15.9166C7.99706 13.482 4.41305 14.259 1.57805 16.1C1.52411 16.1269 1.47895 16.1687 1.44785 16.2204C1.41005 16.2792 1.41005 16.3856 1.41005 16.3856V17.1612C1.41005 17.1612 1.40865 17.311 1.52905 17.3992C1.63545 17.4748 1.76005 17.4818 1.86925 17.4202C6.10145 14.9254 8.30645 16.1882 8.37505 17.5C8.38053 17.5554 8.40138 17.6083 8.43526 17.6526C8.4783 17.7042 8.53584 17.7418 8.60046 17.7604C9.60986 18.0124 11.0757 18.1104 12.4113 17.7604V17.7604Z"
                                fill="var(--buttons_color)"/>
                        </svg>

                    </div>

                    <div v-if="user_type == 'moderator'" v-on:click="moderatorHandler"
                         class="icon alignVertical">
                        <img ref="exit" src="assets/icons/header/black/icon_config.png"/>
                    </div>

                </div>




            </div>
            <div v-if="!this.isMobile && this.switch.btn_promotional.active" style="width: 360px;">
                <BtnPromotional v-if="this.switch.btn_promotional.active && !this.isGuest"/>
            </div>
        </div>



        <Modal v-if="modal_" ref="modal" :modal_type="modal_type" :modal_title="modal_title" :modal_text="modal_text"
               :modal_response="modal_response" :modal_yes="modal_yes" :modal_no="modal_no" :modal_btn="modal_btn"
               :modal_iframe_url="modal_iframe_url"></Modal>

        <Package v-if="modal_package"></Package>
        <PackageBuy v-if="modal_package_buy"></PackageBuy>
    </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import logoLoading from "@/assets/img/loading.gif";
import logoDefault from "@/assets/img/loading.gif";
import Modal from "../../Modal";
import axios from "axios";
import Package from "@/components/Package";
import PackageBuy from "@/components/PackageBuy";
import BtnPromotional from "@/components/Notifications/BtnPromotional.vue";
// import MusicPlayer from "@/components/MusicPlayer";
import $ from 'jquery';
// import LmsMenuNotifications from "@/components/lms/LmsMenuNotifications.vue";

let emitter = require('tiny-emitter/instance');

export default {
    name: "LmsHeader",
    components: {
        // LmsMenuNotifications,
        Modal,
        Package,
        PackageBuy,
        BtnPromotional
        // MusicPlayer
    },
    data() {
        return {
            lmsSlug: 0,
            tools: true,
            logo_: null,
            isMobile: false,
            descs: {
                "badges": {
                    active: true,
                    description: this.$i18n.t('app.vejaSeusBadges')
                },
                "guest": {
                    active: false,
                    description: this.$i18n.t('guest.criarContaDescription')
                },
                "logo": {
                    active: false,
                    description: this.$i18n.t('app.voltarAoMapa')
                },
                "nick": {
                    active: false,
                    description: this.$i18n.t('app.editeSuaConta')
                },
                "points": {
                    active: false,
                    description: this.$i18n.t('app.vejaSuaPosicao')
                },
                "coin": {
                    active: false,
                    description: this.$i18n.t('app.customizeSeuAvatar')
                },
                "selfie": {
                    active: false,
                    description: this.$i18n.t('app.tireSelfies')
                },
                "noti": {
                    active: false,
                    description: this.$i18n.t('app.leiaNotificacoes')
                },
                "menu": {
                    active: false,
                    description: this.$i18n.t('app.menuDeNavegacoes')
                },
                "radio": {
                    active: false,
                    description: this.$i18n.t('app.radio')
                },
                "shutoff": {
                    active: false,
                    description: this.$i18n.t('app.fazerLogout')
                },
                "guestShutoff": {
                    active: false,
                    description: this.$i18n.t('guest.fazerLogout')
                },
                "help": {
                    active: false,
                    description: this.$i18n.t('app.ajudaEContato')
                },
                "conteudo": {
                    active: false,
                    description: this.$i18n.t('app.conteudo')
                },
            },
            notification: false,
            notification_list: [],
            notification_request: false,
            modal_login_: false, photo_player: false, modal_cadastro_: false, modal_validacao_: false, modal_RememberPassword: false, modal_ResetPassword: false, modal_package: false, modal_package_buy: false, modal_guest_buy: false, modal_package_payments: false, modal_coins_buy: false, modal_ticket_gate: false, modal_package_single: false, modal_private_messages: false,
            modal_: false, modal_badge_: false, modal_type: null, modal_title: null, modal_text: null, modal_response: null, modal_yes: null, modal_no: null, modal_btn: null, modal_iframe_url: null,
            options: [
                {
                    language: 'Português',
                    icon: '/assets/icons/header/brasil.svg',
                    code: "pt-br",
                    label: "-br",
                    active: true
                },
                {
                    language: 'Inglês',
                    icon: '/assets/icons/header/usa.svg',
                    code: "en",
                    label: "",
                    active: true
                },
                {
                    language: 'Espanhol',
                    icon: '/assets/icons/header/espanha.svg',
                    code: 'es',
                    label: '',
                    active: true
                },
                {
                    language: 'Francês',
                    icon: '/assets/icons/header/french.svg',
                    code: 'fr',
                    label: '',
                    active: true
                }
            ],
            isOpenLocale: false,
            selectedLanguage: {},
            ww: 0,		  //browser width including scrollbar width
            wh: 0,       //browser height
            showNotifications: false
        }
    },
    created() {
        if(this.getLmsConfigs?.transparent_header) {
            document.querySelector('.menu.logged').style.setProperty('background-color', 'transparent', 'important');
        }
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
        this.logoHandler();
    },
    beforeMount() {
        let root_ = this;

        this.lmsSlug = root_.$route.params.lmsSlug;
        this.$store.dispatch("LmsCart/getCart");

        root_.selectedLanguage = root_.options.filter(lang => {
            return lang.code === root_.$i18n.locale;
        });

    },
    mounted() {
        let root_ = this;
        root_.ww  = document.documentElement.clientWidth;   // $(window).outerWidth();		  //browser width including scrollbar width
        root_.wh  = document.documentElement.clientHeight;  //$(window).height();				    //browser height
        // console.log('WW', root_.ww, root_.wh);

        if (this.checkIOS || this.checkMobile) {
            root_.isMobile = true;
            root_.openChatButton = true;
        }

        document.addEventListener("closeMenu", () => {
            try {
                this.menu_active = false;
                document.getElementById("menu-icon").classList.remove("change");
                document.getElementById("menu").style.display = "none";
            } catch (e) {
                //
            }
        });

        emitter.on("buy-coins", () => {
            root_.openPackage();
        })

        $('#lms-header').parent().css('width', '100%').css('height', '100%');


    },
    beforeDestroy() {
        emitter.off("buy-coins");

        document.removeEventListener("click", this.handleClickOutsideMenu);
    },
    methods: {
        notificationsHandler(){
            this.$app.camera = false;
            this.$app.notifications_count = 0;
            this.$app.getNotifications();
            this.$app.mobileClose();
        },
        getShowCart() {
            return this.getLmsConfigs?.show_cart;
        },
        checkForIdAndLms(array, id) {
            return array.some(item => item.id === id && item.lms !== null);
        },
        openDropdownLocale() {

            this.isOpenLocale = !this.isOpenLocale;

        },
        closeDropdown() {

            // this.isOpenLocale = false;

        },
        ...mapActions([
            "update_logged", "update_token", "update_switch",
        ]),
        mobileClose() {
            try {
                var mobile = this.$refs["mobile"].$refs["mobile"];
                mobile.classList.remove("change-mobile-out");
                mobile.classList.remove("change-mobile-in");
                mobile.classList.add("change-mobile-out");
            } catch (e) {
                e;
            }

            let eventName = new Event("closeMenu");
            document.dispatchEvent(eventName);
        },
        errorImage(event) {
            console.log("errorImage?");
            event.target.src = logoLoading;
            // console.clear();
        },
        link(url) {
            if (this.$route.name !== url) {
                this.$router.push({name: url});
            }
        },
        /**
         * Direciona o usuário para a página inicial ou para uma página específica do LMS,
         * baseado nas condições de sessão e rota.
         */
        goHomeLMS() {
            // Verifica se a sessão padrão do LMS não está presente. A função 'checkForIdAndLms'
            // determina se uma sessão específica (identificada por 'this.map_sessions.default')
            // existe dentro de 'this.sessions'.
            if(!this.checkForIdAndLms(this.sessions, this.map_sessions.default)) {
                // Se a sessão padrão do LMS não existir, redireciona para a página inicial.
                this.$store.dispatch('LMS/disableLms')
                    .then(() => {
                        document.body.classList.remove('lms');
                        document.body.classList.remove('transparent');
                        let header = document.getElementsByClassName('menu logged')[0];
                        header.style.setProperty('background-color', 'var(--headers_color_logged)', 'important');
                    }).finally(() => {
                    return this.$router.push('/map');
                });
            } else {
                // Este bloco condicional verifica se a rota atual não é a mesma que a rota alvo do LMS.
                // Isso evita redirecionamentos redundantes para a mesma página, se já estiver nela.
                if(this.$route.path != '/lms/' + this.getLms.slug) {
                    // Se a rota atual for diferente, redireciona para a página do LMS
                    // associada com o slug atual do LMS.
                    return this.$router.push('/lms/' + this.getLms.slug);
                }
            }
        },
        logoHandler() {
            if (localStorage.getItem("eventmap")) {
                this.logo_ = this.eventlogo || this.design?.logo || this.getCookie("design_logo") || logoDefault;
                this.logoFavicon_ = this.faviconLogo || this.design?.logoFavicon || this.getCookie("design_logo_favicon") || logoDefault;
            } else {
                this.logo_ = this.design?.logo || this.getCookie("design_logo") || logoDefault;
                this.logoFavicon_ = this.design?.logoFavicon || this.getCookie("design_logo_favicon") || logoDefault;
            }
            this.changeFavicon();
        },
        changeFavicon() {
            const favicon = document.querySelector('link[rel="icon"]');
            favicon.href = this.logoFavicon_;
        },
        getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(";");
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        exitLocal(response) {
            if (this.iframecomponent) {
                this.modal(
                    "confirmation",
                    this.$i18n.t('app.atencao'),
                    this.$i18n.t('app.desejaRealmente'),
                    response,
                    this.$i18n.t('app.sim'),
                    this.$i18n.t('app.nao')
                );
            } else {
                response(1);
            }
        },
        logout() {
            if (this.isGuest) {
                this.modal("confirmation", this.$i18n.t('app.atencao'), this.$i18n.t('guest.fazerLogout'), this.logoutConfirmation);
            } else {
                this.modal("confirmation", this.$i18n.t('app.atencao'), this.$i18n.t('app.desejaRealmenteSair'), this.logoutConfirmation);
            }
            this.$store.dispatch("signup/reset");
            let eventName = new Event("closeMenu");
            document.dispatchEvent(eventName);
        },
        moderatorHandler() {
            this.group_active = true;
        },
        getNotifications(change = true) {
            // this.analytics("click_notification", {});
            if (change) {
                this.notification = !this.notification;
                this.updatePopupNotifications()
            }
            if (this.notification) {
                this.wait(true);
                this.notification_request = true;
                let headers = {
                    "Content-Type": "application/json;charset=UTF-8",
                    Access: "application/json",
                    language: this.$i18n.locale, Authorization: `Bearer ${this.token}`,
                };
                axios
                    .get(this.$url_api + "api/NotificationsList", {headers: headers})
                    .then((response) => this.getNotificationsResponse(response))
                    .catch((error) => this.getNotificationsError(error.response));
            }
        },
        updatePopupNotifications() {
            this.notification_list = this.NotificationsList;
            this.popup_notifications = this.notification_list.filter(_ => _.popup && _.show_popup);
        },
        wait(b, unity_ = null) {
            // this.$refs["loader"].style.display = b ? "block" : "none";

            // if ((b == false) && (this.loading_unity == true))
            if (unity_ != null) {
                // if (unity_ === true)
                this.loading = b;
                this.loading_unity = b;
            } else {
                if (!this.loading_unity) {
                    this.loading = b;
                }
            }

            //console.log('WAIT => ', b, this.loading_unity);
        },
        getNotificationsResponse(obj) {
            this.wait(false);
            if (obj.data.status === "success") {
                this.notification = true;
                this.update_notification_datas(obj.data.data.notifications)
                this.updatePopupNotifications()
            }
            this.notification_request = false;
        },
        getNotificationsError(obj) {
            obj;
            this.wait(false);
            this.notification_request = false;
        },
        handleScroll(event) {
            event;
            var scrl_lmt = 50,
                top = window.pageYOffset || document.documentElement.scrollTop,
                // left     = window.pageXOffset || document.documentElement.scrollLeft,
                // header = document.getElementById('lms-header');
                header = document.getElementsByClassName('menu logged')[0],
                container = document.getElementsByClassName('js-container-header')[0];
            container;
            if (top > scrl_lmt) {
                header.classList.add('scrolled');
                header.style.setProperty('background-color', 'var(--headers_color_logged)', 'important');
            } else {
                header.classList.remove('scrolled');
                if(this.getLmsConfigs.transparent_header) {
                    header.style.setProperty('background-color', 'transparent', 'important');
                }
            }
        },
        handleResize(event) {
            event;
            let root_ = this;
            root_.ww  = document.documentElement.clientWidth;   // $(window).outerWidth();		  //browser width including scrollbar width
            root_.wh  = document.documentElement.clientHeight;  //$(window).height();				    //browser height
            // console.log('WWSSSS', root_.ww, root_.wh);
        },
        openPackage() {
            if(this.switch.finance_profile_menu && this.switch.has_packages) {
                // this.modal_package = true;
                this.modalsHandler();
                this.modal_package = (this.modal_coins_buy) ? false : true;
            }
        },
        pointsExit(value) {
            if (value == 1) {
                if(this.switch.event_menu && this.switch.event_menu['ranking_pontos']) {
                    this.link("Ranking");
                    this.iframecomponent = false;
                }
            }
        },
        profileExit(value) {
            if (value == 1) {
                this.link("Profile");
                this.iframecomponent = false;
            }
        },
        modalsHandler() {
            this.modal_cadastro_ = false;
            this.notification = false;
            this.camera = false;
            this.modal_login_ = false;
            this.modal_validacao_ = false;
            this.modal_RememberPassword = false;
            this.modal_ResetPassword = false;
            this.modal_PoliticaDePrivacidade = false;
            this.modal_Termos = false;
            this.modal_package = false;
            this.modal_package_buy = false;
            this.modal_package_payments = false;
            this.modal_coins_buy = false;
            this.modal_ticket_gate = false;
            this.modal_package_single = false;
            this.modal_private_messages = false;
            this.modal_quest = false;

            switch (this.$route.name) {
                case "Signup":
                    this.modal_cadastro_ = true;
                    break;
                case "Login":
                    this.modal_login_ = true;
                    break;
                case "EmailConfirmation":
                    this.modal_validacao_ = true;
                    break;
                case "RememberPassword":
                    this.modal_RememberPassword = true;
                    break;
                case "ResetPassword":
                    this.modal_ResetPassword = true;
                    break;
                case "PoliticaPage":
                    this.modal_PoliticaDePrivacidade = true;
                    break;
                case "TermosPage":
                    this.modal_Termos = true;
                    break;
                default:
                    var dados = this.$store.getters['signup/cadastro'];
                    for (const dadosKey in dados) {
                        if(dados[dadosKey] && dados[dadosKey].length>0){
                            this.modal_cadastro_=true;
                        }
                    }
            }
        },
        modal(type, title, txt, response, y, n, b, iframe) {
            this.modal_type = type;
            this.modal_title = title;
            this.modal_text = txt;
            this.modal_response = response;
            this.modal_yes = y;
            this.modal_no = n;
            this.modal_btn = b;
            this.modal_iframe_url = iframe;
            this.modal_ = true;
        },
        logoutConfirmation(r) {
            if (r === 1) {
                this.analytics("logout_btn");
                this.wait(true);
                let form_data = new FormData();
                let headers = {
                    "Content-Type": "application/json;charset=UTF-8",
                    'Access': "application/json",
                    'language': this.$i18n.locale,
                    'Authorization': `Bearer ${this.token}`
                };
                axios
                    .post(this.$url_api + "api/logout", form_data, {headers: headers})
                    .then((response) => this.$app.logoutResponse(response))
                    .catch((error) => this.logoutError(error.response));
            }
        },
        bodyOverflow(change = true) {
            let element = document.getElementsByTagName("body")[0];
            if (change) {
                element.style.overflow = "hidden";
                return;
            }
            element.style.overflow = "auto";
        },
        analytics(event_name, data) {
            event_name, data;
            //page, event, data;
            if (this.$gtag && this.securityContainer.admin_config.analytics) {
                this.$gtag.event(event_name);
            }
            //console.log('analytics => ', event_name, data);
        },
        logoutError(obj) {
            this.varifyLoggedError(obj.data);
            this.wait(false);
        },
        varifyLoggedError(error) {
            if (error.status == 401 || error.message == "Unauthenticated.") {
                this.logoutEnd();
            }
        },
        logoutEnd() {
            localStorage.removeItem("user");
            this.deleteCookie("guest_last_join");
            localStorage.removeItem("design_eventlogo");

            this.update_logged(false);

            if (this.isGuest) {

                this.update_guest(false)
                localStorage.removeItem("guest")

            }
            this.update_token(null);
            //this.link("Home");

            localStorage.removeItem('redirectPath');
            localStorage.removeItem('userSettedLanguage');
            this.modal_private_messages = false;

            this.getSetup();

            if ((localStorage.getItem("eventmap")) && (localStorage.getItem("eventmap") != ''))
            {
                window.location.href = this.$url + '#/' + localStorage.getItem("eventmap");
            }
            else {
                console.log('caindo no redirect do eventmap :: lms')
                this.$router
                    .push({ path: '/' })
                    .then(() => {
                        this.$router.go();
                    });
            }


            if (this.switch.without_landing_page == 'without_landing_page') {
                // location.reload(true)
                this.createGuest()
            }
        },
        deleteCookie(name) {
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        },
        getSetup() {
            return axios
                .get(this.$url_api + "api/setup", {headers: {'language': this.$i18n.locale,}, params: { event: localStorage.getItem("eventmap") }})
                .then((response) => this.getSetupResponse(response));
        },
        getSetupResponse(data) {
            this.show_captcha = (data && data.data && data.data.captcha && data.data.captcha == 1);
            this.tabname = data.data.Nome_Aba;
            if (this.$route.name=="Signup" && this.$route.query._==="84502530"){
                data.data.waiting_mode = false;
            }
            this.update_switch(data.data);
            // console.log('switch =>', this.switch)

            if(this.switch.multilanguages && this.switch.active_languages && Object.keys(this.switch.active_languages).length > 0) {
                this.options = this.options.map(option => {
                    const languageCode = option.code;
                    const isActive = this.switch.active_languages[languageCode];

                    option.active = isActive === 1;

                    return option;
                });
            }


            this.setCookie("switch_Nome_Aba",this.switch.Nome_Aba)

            // caso o admin mude para nao habilitar o multilingua, força o usuário que estava em outra lingua para a lingua padrao
            if( !this.switch.multilanguages ) {
                this.$i18n.locale = this.switch.default_language;
                localStorage.setItem('language', this.$i18n.locale);
                localStorage.removeItem('userSettedLanguage');
            } else {
                if( !localStorage.getItem('userSettedLanguage') ) {
                    this.$i18n.locale = this.switch.default_language;
                    localStorage.setItem('language', this.$i18n.locale);
                    localStorage.setItem('userSettedLanguage', this.$i18n.locale);
                }
            }

        },
        setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        goToCheckout(){

            if(this.cartHasItens){
                this.$router.push({
                    name: "LmsCheckout"
                });
            }

        },
        setLocale(lang){
            let root_ = this;

            this.$i18n.locale = lang;
            root_.selectedLanguage = root_.options.filter(lang => {
                return lang.code === root_.$i18n.locale;
            });
            localStorage.setItem('language', this.$i18n.locale);
            localStorage.setItem('userSettedLanguage', this.$i18n.locale);  // nova variavel para guardar se o usuario setou outra lingua para comparação com a lingua padrao do evento
            location.reload();
        },
        toggleMenu(){
            $('#lms-header').toggleClass('active');
        },
        showNotification() {

            this.showNotifications = true;

            if (document.body.classList.contains("lms")) {
                document.addEventListener("click", this.handleClickOutsideMenu);

            }
        },
        handleClickOutsideMenu() {
            // Referência ao menu de notificações
            const dropdownMenu = this.$refs.notificationsMenu;

            // Verifica se o clique foi fora do menu de notificações
            if (dropdownMenu && !dropdownMenu.contains(event.target) && this.showNotifications) {
                this.closeMenuNotifications();
            }
        },
        closeMenuNotifications() {
            this.showNotifications = false;
            document.removeEventListener("click", this.handleClickOutsideMenu);
        }
    },

    computed: {
        ...mapGetters([
            "switch", "isGuest", "design", "nickname", "smartphone_options", "LibraryName", "user_type", "checkIOS", "checkMobile",
            "user_picture", "NotificationsList", "notifications_count", "notifications_pendent_ids", "TotalPoints", "TotalCoins", "TotalBadges", "name", "email",
            "radio", "map_sessions", "sessions", "securityContainer", "token"
        ]),
        ...mapGetters("LMS", ["isLms", "getLms", "getLmsConfigs"]),
        cartHasItens(){
            return this.$store.getters["LmsCart/getCart"]?.length ?? false;
        }
    }
}
</script>


<style lang="scss">

$iconsSize: 25px;
$headerHeight: 62px;      // header height
$logoMW: 200px;           // logo max width
$logoMH: 70px;            // logo max height
$menuLinksHeight: 330px;  // height na parte dos links do menu

.lms {
    #app {
        .modals__content--header {
            p {
                margin-bottom: 0;
            }
        }

        header {
            .menu {

                height: auto;     // 60px;
                max-height: none; // 60px;
                height: calc($headerHeight + 1.5rem);

                &.logged {
                    // background-color: transparent !important;
                    position: absolute;
                    top: 0;
                    //padding: 1.5rem 0 0 0;

                    #menu_list {
                        margin-top: 5px;
                    }

                    &.scrolled {
                        background: var(--headers_color_logged) !important;
                        box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
                        // height: auto;
                        // max-height: none;
                        // line-height: 0 !important;
                        font-size: 0 !important;
                        padding: 0.5rem 0 0.5rem 0;
                        margin-bottom: 0 !important;
                        height: calc($headerHeight + .5rem);
                        #package-buy {
                            // margin-top: 0 !important;
                        }

                    }

                    .container {
                        transition-duration: 0.3s;
                        align-items: center;
                        height: 100%;
                        flex-flow: column wrap;
                        align-content: space-between;
                    }
                }
            }
        }

        #package-buy, .package {
            .modals__content--header.alignVertical {
                justify-content: center;
            }
        }

    }

    &.swal2-shown {
        overflow-y: scroll !important; /* Força a exibição da barra de rolagem, evita deslocamento da página quando ela aparece */
    }

}

#lms-header.menu__map {
    height: 100%;
    background-color: transparent !important;
    transition-duration: 0.3s;
    .container{
        justify-content: center;
    }

    .menu__map--content---logos{
        width: auto;
        max-width: 30%;
        align-items: center;
        align-items: flex-end;
        display: flex;
        flex-wrap: wrap;

        #logomap {
            max-width: $logoMW;
            max-height: $logoMH;
            height: auto;
            width: 100%;
            object-fit: contain;
        }

    }

    .alignVertical {
        justify-content: center;
    }

    .menu__map--content---mapMenu {
        height: 100%;
        width: 70%;
        max-width: 70%;
        margin-right: 5px;

        .user-avatar {
            position: relative;
            background-size: cover;
            background-position: top center;
            background-repeat: no-repeat;
            background-blend-mode: saturation;
            height: 60px;
            width: 60px;
            border-radius: 50%;
            object-fit: cover;
            object-position: top center;
        }

        #_noti {
            margin-bottom: 7px;

            .notification {
                &:after {
                    top: 0;
                    right: 0;
                    z-index: 990;
                }
            }

        }

        .tools {

            .icon {
                border: none;
                width: $iconsSize;
                height: $iconsSize;
            }

        }

        i {
            font-size: $iconsSize;
        }

        .infos {
            background: transparent;

            span {
                color: var(--buttons_color);
            }
        }

        #menu_list {
            position: relative;

            &.show-notifications-mark {
                &:after {
                    content: "";
                    position: absolute;
                    bottom: 18px;
                    left: 16px;
                    width: 8px;
                    height: 8px;
                    border-radius: 40px;
                    background: #21ff6c;
                    box-shadow: 0px 0px 13px #21ff6c;
                    border: 2px solid #00ea4f;
                    box-sizing: border-box;
                    z-index: 990;
                }
            }


        }

        .iconLanguage {

            border-radius: 10px;
            border: 1px solid #E1E1E1;
            background: #FFF;

            .dropdown-locale {

                .dropdown-menu-locale {
                    display: none !important;

                    &.show {
                        display: block !important;
                    }

                }

                .dropdown-item {
                    padding-top: 0;
                    padding-bottom: 0;
                    &:active {
                        background-color: transparent;
                    }
                }

                .language {
                    color: #706F6F;
                    font-family: "Hanken Grotesk", sans-serif;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    text-transform: initial;
                    margin-right: 7px;
                    margin-left: 10px;

                }

            }

            margin: 0;

            .v-select {
                padding: 0;

                .vs__selected {
                    padding: 2px;
                    margin: 0;
                }

                .vs__dropdown-toggle{
                    background-color: transparent;
                }


                .vs__dropdown-menu {
                    min-width: 31px;
                    background-color: transparent !important;
                }

                #vs2__listbox {
                    background-color: transparent;


                }

            }
        }


        .dropdown {
            &:hover {
                .dropdown-menu {
                    // display: block;
                    margin-top: 0px; /* remove the gap so it doesn't close */
                    opacity: 1 !important;
                    visibility: visible !important;
                }
            }

            .dropdown-menu.keep-open {
                margin-top: 0px; /* remove the gap so it doesn't close */
                opacity: 1 !important;
                visibility: visible !important;

                width: 400px !important;
                max-width: 400px !important;
                height: 700px;
                overflow: hidden;
            }

            .dropdown-menu {
                border: none;
                box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.15);
                display: block;
                opacity: 0;
                border-radius: 10px;
                visibility: hidden;
                transition: all .5s ease;
                max-width: 216px;

                .dropdown-item {
                    cursor: pointer;
                    color: rgba(var(--bs-link-color-rgb),var(--bs-link-opacity,1));
                    &:active {
                        background-color: transparent;
                    }
                }

                &.hamburguer-menu {
                    max-width: 216px;
                    right: -1px;
                    top: 36px;
                    font-size: 16px;
                    left: auto;
                    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);

                    .dropdown-item {
                        // color: var(--fonts_color);
                        color: #706F6F;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        padding-bottom: 0;
                        padding-top: 0;
                        line-height: 28px;

                        &.profile {

                            position: relative;

                            &:before {
                                content: "";
                                position: absolute;
                                top: -5px;
                                left: 4%;
                                width: 93%;
                                height: 1px;
                                background-color: #e1e1e1;
                            }
                        }

                    }

                    .notifications-count {
                        color: #000000;
                        background-color: #B0E000;
                        border-radius: 50%;
                        padding: 3px 6px;
                        font-size: 12px;
                    }




                    .user-picture {
                        padding-left: 16px;
                        padding-right: 16px;

                        .picture{
                            margin-right: 15px;
                        }

                        .bi-person-circle {
                            font-size: 45px
                        }

                        .currency {

                            border-bottom: 1px solid #E1E1E1;

                            p {
                                font-size: 13px;
                                color: #B1B1B1;
                                text-align: center;
                                leading-trim: both;
                                text-edge: cap;
                                font-family: "Hanken Grotesk", sans-serif;
                                font-size: 16px;
                                font-style: normal;
                                font-weight: 600;
                                line-height: normal;
                            }

                            svg {
                                fill: var(--buttons_color);
                            }

                            #point {
                                position: relative;
                                width: 100%;
                                height: 34px;
                                cursor: pointer;
                                margin-right: 9px;

                            }
                            #coin {
                                position: relative;
                                width: 100%;
                                height: 34px;
                                cursor: pointer;
                                margin-right: 9px;

                            }
                            #badgeCounter {
                                position: relative;
                                width: 100%;
                                height: 34px;
                                cursor: pointer;
                                margin-right: 9px;

                            }



                        }



                        .user-info {
                            margin:0;
                            text-transform: initial;
                            width: calc(100% - 55px);

                            span{
                                margin-right: 0;
                                margin-left: 0;
                            }

                            .user-info-name {
                                font-family: "Open Sans", sans-serif;
                                font-size: 15px;
                                font-weight: 700;
                                line-height: 20px;
                                letter-spacing: 0.5px;
                                text-wrap: wrap !important;
                                text-align: left;
                                // color: var(--fonts_color); For while forcing the color to not break the layout
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                color: #706F6F;
                            }

                            .user-info-email {
                                font-family: "Open Sans", sans-serif;
                                font-size: 11px;
                                font-weight: 700;
                                line-height: 20px;
                                letter-spacing: 0em;
                                text-align: left;
                                color: var(--fonts_color);
                                text-transform: none;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            }

                        }

                    }

                }

                .menu-links-wrapper{
                    overflow-x: hidden;
                    overflow-y: auto;
                    height: 100%;
                    width: 100%;
                    position: relative;
                    max-height: $menuLinksHeight;
                }

                #menu-list-close{
                    display: none;
                    position: absolute;
                    right: 10px;
                }

            }

            span#menu-list{
                display: block;
            }
            span#menu-list-click{
                display: none;
            }


        }

        .canCheckout {
            cursor: pointer;
            position: relative;
            .notification-cart {
                position: relative;
                &:after {
                    content: "";
                    position: absolute;
                    bottom: 16px;
                    left: 20px;
                    width: 8px;
                    height: 8px;
                    border-radius: 40px;
                    background: #21ff6c;
                    box-shadow: 0px 0px 13px #21ff6c;
                    border: 2px solid #00ea4f;
                    box-sizing: border-box;
                    z-index: 990;
                }
            }

        }


    }

    #nick {
        i {
            font-size: $iconsSize;
        }
    }

    #_help {
        i {
            font-size: $iconsSize;
            color: var(--buttons_color);
        }
    }

    #_shutoff, #_noti {
        cursor: pointer;
        svg {
            width: $iconsSize;
            height: $iconsSize;
        }
    }

    .tools {
        .iconAjuda {
            width: $iconsSize;
            height: $iconsSize;
        }
    }

}



@media only screen and (max-width: 1400px) {
    // #app header #lms-header .container,
    // .container-md, .container-sm {
    //   max-width: 100%;
    //   width: 100%;
    // }
}

@media only screen and (max-width: 1200px) {
    #app header #lms-header .container,
    .container-md, .container-sm {
        max-width: 100%;
        width: 100%;
    }
}

@media only screen and (max-width: 992px) {

    #app header #lms-header {

        // .menu__map--content---logos {
        //   min-height: 50px;
        // }

        .menu__map--content---mapMenu {

            // width: 100%;

            .tools {
                background: transparent !important;
            }



            .infos {
                background-image: none !important;
                background-color: initial;
                width: initial;
                height: initial;
                max-width: initial !important;
                right: initial;
                bottom: initial;
                position: initial;

                #nick {
                    position: initial;
                    left: initial;
                    top: initial;
                }


            }

            // .dropdown-menu.hamburguer-menu {
            //   right: -80px;
            //   left: auto;
            // }


        }

    }

}

@media only screen and (max-width: 768px) {

    #app header #lms-header .menu.logged #lms-header .container {
        flex-wrap: nowrap !important;
    }

    #lms-header.menu__map .menu__map--content---logos{
        max-width: 50%;
    }
    #lms-header.menu__map .menu__map--content---mapMenu{
        max-width: 50%;
    }

    #lms-header.menu__map .menu__map--content---logos #logomap{
        max-width: 140px;
        max-height: 60px;
    }

}

#lms-header {
    #logomap {
        max-width: 200px;
        max-height: 50px;
    }

}

// adjusts from original header?
@media (max-width: 1000px) {

    .lms #lms-header.menu__map .menu__map--content---mapMenu .infos{
        width: auto;
        position: relative;
        right: auto;
        left: auto;
        top: auto;
        bottom: auto;
    }
    .lms  header .menu__map--content---logos img{
        position: relative !important;
    }
}
@media (max-width: 600px) {
    .lms header .menu__map {
        height: 100% !important;
    }
}
@media (min-width: 600px) {
    .lms #lms-header #logomap {
        max-width: $logoMW;
        max-height: $logoMH;
        height: auto;
        width: 100%;
        object-fit: contain;
    }
}



</style>